
import FaqCard from '@/components/FaqCard';
import ImageHeader from '@/components/core/ImageHeader';
import tableLoading from '@/components/tableLoading';
export default {
  scrollToTop: true,
  head() {
    return {
      title: this.title + " | Goa App",
      meta: [{
        hid: 'og:title',
        property: 'og:title',
        content: this.title + " | Goa App"
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: this.title + " | Goa App"
      }
      ],
    }
  },
  //   jsonld() {
  //   const items = this.faqData.map((item, index) => ({
  //     '@type': 'Question',
  //     position: index + 1,
  //     "name":item.question,
  //     "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text":  item.answer
  //       },
  //   }));
  //   return {
  //     '@context': 'https://schema.org',
  //     '@type': 'FAQPage',
  //      mainEntity: items,
  //   };
  // },
  components: {
    FaqCard,
    ImageHeader,
    tableLoading
  },


  data() {
    return {
      title: 'Captions',
      search: '',
      skip: 0,
      page: 1,
      totalNumberOfpages: 0,
      listings: {},
      busy: false,
      productObj: [],
      loading: true,
      initialLoading: true,
      listingLoading: true,
    }
  },
  layout: 'transparent-nav',
  fetchOnServer: false,

  mounted() {
    this.getListings(0)
  },
  methods: {
    loadMore() {
      this.busy = false;
      if (this.listings.isMoreDataAvailable) {
        this.busy = true;
        setTimeout(() => {
          this.page++
          this.callback(this.page)
        }, 1000);
      }
    },

    // callback for the pagination plugin
    callback: function (page) {
      this.page = page;
      let pagination = (page - 1) * 20;
      if (pagination < 0) {
        pagination = 0;
      }
      this.getListings(pagination);
    },

    // TO get SUBSCRIPTIONS using pagination
    getListings(skip) {
      //this.listingLoading = true;
      var formData = new URLSearchParams();
      formData.append("skip", skip);
      this.$axios.get(`/api/caption/getcaption/${skip}`)
        .then(response => {
          this.initialLoading = false;
          let value = this.getCryptKey(response.data);
          this.productObj.push(...value.captions)
          this.listings = value;
          if (skip == 0) {
            this.page = 1;
          }
          this.totalNumberOfpages = Math.ceil(this.listings.totalCount / 20);
          this.$nextTick(() => {
            this.busy = false;
            this.listingLoading = false;
          })
        })
        .finally(() => {
          this.$nextTick(() => {
            this.listingLoading = false;
          })
        })
    },
    goTocaption(captionSlug) {
      this.$router.push({
        path: "/caption/" + captionSlug
      });
    },
  }
}

